import { useEffect, useState } from "react";
import { ParallaxProvider, Parallax } from "react-scroll-parallax";
import { useInView } from "react-intersection-observer";
import Rank1Q from "../../images/Rank1Q.png";
import Rank2Q from "../../images/Rank2Q.png";
import Rank3Q from "../../images/Rank3Q.png";
import Rank4Q from "../../images/Rank4Q.png";
import Rank5Q from "../../images/Rank5Q.png";
import ProductCard from "./ProductCard";

const RowBestQ = () => {
  const [refFact1, refFact1InView] = useInView();
  const [refFact1isVisible, setrefFact1IsVisible] = useState(false);
  useEffect(() => {
    if (refFact1InView && !refFact1isVisible) {
      setrefFact1IsVisible(true);
    } else if (!refFact1InView && refFact1isVisible) {
      setrefFact1IsVisible(false);
    }
  }, [refFact1isVisible, refFact1InView]);

  return (
    <div className="color-dk-r">
      <div className="row m-0 flex-row-reverse text-center">
        <div className="stickyRowHeaders2 col-lg-4 col-12 d-flex align-items-center justify-content-center ">
          <div className="d-lg-none d-inline">
            <div>Best Selling Products</div>
            <div>(Quantity-wise)</div>
          </div>
          <div className="d-none d-lg-block">
            <ParallaxProvider>
              <Parallax
                translateY={[-200, 100]}
                opacity={[1, 0.8]}
                easing="easeOut"
                scale={[0.8, 1]}
              >
                <div>Best Selling Products</div>
                <div>(Quantity-wise)</div>
              </Parallax>
            </ParallaxProvider>
          </div>
        </div>

        <div className="col-lg-8 col-12 text-start color-dk-dark line-height-lg px-0 bg-color-w py-1">
          <div
            ref={refFact1}
            className={
              refFact1isVisible
                ? "fade-in-section is-visible row m-0 text-center py-2"
                : "fade-in-section row m-0 text-center py-2"
            }
          >
            <div className="row mx-0 justify-content-center">
              <ProductCard
                img={Rank1Q}
                link="https://www.digikala.com/product/dkp-86862/"
                title={"OK Stand mobile and tablet holder"}
                rank={"1"}
              />
            </div>
            <div className="row mx-0 justify-content-center">
              <ProductCard
                img={Rank2Q}
                link="https://www.digikala.com/product/dkp-3501717/"
                title={"Melt Blown Face Masks"}
                rank={"2"}
              />
              <ProductCard
                img={Rank3Q}
                link="https://www.digikala.com/product/dkp-5086666/"
                title={"inpods 12 Bluetooth Hands-Free"}
                rank={"3"}
              />
              <ProductCard
                img={Rank4Q}
                link="https://www.digikala.com/product/dkp-847467/"
                title={"Tabiat Canned Fish in vegetable oil | 180gr"}
                rank={"4"}
              />
              <ProductCard
                img={Rank5Q}
                link="https://www.digikala.com/product/dkp-3693651/Rank"
                title={"Panberiz Menstrual pad | Large Blue - 10pieces"}
                rank={"5"}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RowBestQ;
